import { DataGrid } from 'devextreme-react';
import {
  Button,
  Column,
  Editing,
  FilterRow,
  HeaderFilter,
  Pager,
  Paging,
} from 'devextreme-react/data-grid';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { addIdBeneficio } from '../../store/modules/beneficio/action';
import { gridDataSourceBeneficioFilter } from './BeneficioService';
import { postAndPut } from './object';

export default function BeneficioFilter({ setForm, setToggle, initialForm }) {
  const dispatch = useDispatch();
  const [pageIndex, setPageIndex] = useState(null);
  const [pageSize, setPageSize] = useState(15);

  const applyFilterTypes = [
    {
      key: 'auto',
      name: 'Immediately',
    },
    {
      key: 'onClick',
      name: 'On Button Click',
    },
  ];
  const filterOptions = {
    showFilterRow: true,
    showHeaderFilter: true,
    currentFilter: applyFilterTypes[0].key,
  };

  function handleOptionChange(event) {
    if (event.fullName === 'paging.pageSize' && event.value !== pageSize) {
      setPageSize(event.value);
      setPageIndex(0);
    }

    setPageIndex(null);
  }

  function handleEdit(e) {
    setToggle(true);
    setForm(initialForm);
    dispatch(addIdBeneficio(e.row.data.id));
    const newForm = e.row.data;
    setForm({
      ...postAndPut(newForm),
    });
  }

  return (
    <>
      <DataGrid
        dataSource={gridDataSourceBeneficioFilter}
        remoteOperations={true}
        showBorders={true}
        allowColumnReordering={true}
        allowColumnResizing={true}
        columnAutoWidth={true}
        onOptionChanged={handleOptionChange}
      >
        <Editing mode="row" useIcons allowDeleting />
        <Pager
          allowedPageSizes={[7, 15, 30]}
          visible={true}
          showPageSizeSelector={true}
          showInfo={true}
        />
        <Paging defaultPageSize={pageSize} pageIndex={pageIndex} />
        <FilterRow
          visible={filterOptions.showFilterRow}
          applyFilter={filterOptions.currentFilter}
        />
        <HeaderFilter />

        <Column
          dataField="descricao"
          filterOperations={false}
          allowEditing={false}
          alignment="left"
        >
          <HeaderFilter groupInterval={70} />
        </Column>

        <Column type="buttons" width={100}>
          <Button hint="Editar" visible icon="edit" onClick={handleEdit} />
          <Button name="delete" visible hint="Deletar" icon="trash" />
        </Column>
      </DataGrid>
    </>
  );
}
